
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class InstamojoSettingsDialog extends Serenity.EntityDialog<InstamojoSettingsRow, any> {
        protected getFormKey() { return InstamojoSettingsForm.formKey; }
        protected getIdProperty() { return InstamojoSettingsRow.idProperty; }
        protected getLocalTextPrefix() { return InstamojoSettingsRow.localTextPrefix; }
        protected getNameProperty() { return InstamojoSettingsRow.nameProperty; }
        protected getService() { return InstamojoSettingsService.baseUrl; }
        protected getDeletePermission() { return InstamojoSettingsRow.deletePermission; }
        protected getInsertPermission() { return InstamojoSettingsRow.insertPermission; }
        protected getUpdatePermission() { return InstamojoSettingsRow.updatePermission; }

        protected form = new InstamojoSettingsForm(this.idPrefix);

    }
}